import { Languages } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { SUPPORTED_LOCALES } from '@/i18n';
import type { SupportedLocale } from '@/i18n';
import { cn } from '@/lib/utils';

/** Footer language switcher - persisted by i18next's localStorage detector. */
export function LanguageSwitcher() {
  const { t, i18n } = useTranslation('common');
  const current = (i18n.resolvedLanguage ?? 'en').split('-')[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        className="bevel bg-btn font-display flex items-center gap-1.5 px-2.5 py-1 text-[10px] uppercase text-titletext outline-none transition-[filter] hover:brightness-112 focus-visible:ring-2 focus-visible:ring-ring"
        aria-label={t('language.label')}
      >
        <Languages className="size-3.5" />
        {current.toUpperCase()}
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {SUPPORTED_LOCALES.map((locale: SupportedLocale) => (
          <DropdownMenuItem
            key={locale}
            onSelect={() => void i18n.changeLanguage(locale)}
            className={cn(locale === current && 'text-orange')}
          >
            {t(`language.${locale}`)}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
